const others = [
  {
    name: 'arrow-50',
    type: 'other',
    size: '50px'
  },
  {
    name: 'arrow-down-10',
    type: 'other',
    size: '10px'
  },
  {
    name: 'arrow-down-9',
    type: 'other',
    size: '9px'
  },
  {
    name: 'arrow-up-10',
    type: 'other',
    size: '10px'
  },
  {
    name: 'arrow-up-9',
    type: 'other',
    size: '9px'
  },
  {
    name: 'checkmark-12',
    type: 'other',
    size: '12px'
  },
  {
    name: 'checkmark-14',
    type: 'other',
    size: '14px'
  },
  {
    name: 'chevron-down-13',
    type: 'other',
    size: '13px'
  },
  {
    name: 'chevron-up-13',
    type: 'other',
    size: '13px'
  },
  {
    name: 'chevron-down-25',
    type: 'other',
    size: '25px'
  },
  {
    name: 'chevron-left-25',
    type: 'other',
    size: '25px'
  },
  {
    name: 'chevron-right-25',
    type: 'other',
    size: '25px'
  },
  {
    name: 'chevron-up-25',
    type: 'other',
    size: '25px'
  },
  {
    name: 'clear-10',
    type: 'other',
    size: '10px'
  },
  {
    name: 'clear-16',
    type: 'other',
    size: '16px'
  },
  {
    name: 'clear-fill-16',
    type: 'other',
    size: '16px'
  },
  {
    name: 'close-10',
    type: 'other',
    size: '10px'
  },
  {
    name: 'collapse-9',
    type: 'other',
    size: '9px'
  },
  {
    name: 'collapse-fill-19',
    type: 'other',
    size: '19px'
  },
  {
    name: 'collapse-fill-25',
    type: 'other',
    size: '25px'
  },
  {
    name: 'download-17',
    type: 'other',
    size: '17px'
  },
  {
    name: 'expand-9',
    type: 'other',
    size: '9px'
  },
  {
    name: 'expand-fill-19',
    type: 'other',
    size: '19px'
  },
  {
    name: 'expand-fill-25',
    type: 'other',
    size: '25px'
  },
  {
    name: 'export-16',
    type: 'other',
    size: '16px'
  },
  {
    name: 'half-check-12',
    type: 'other',
    size: '12px'
  },
  {
    name: 'link-arrow-left-17',
    type: 'other',
    size: '17px'
  },
  {
    name: 'link-arrow-right-17',
    type: 'other',
    size: '17px'
  },
  {
    name: 'livechat-popover-36',
    type: 'other',
    size: '36px'
  },
  {
    name: 'livechat-popover-32',
    type: 'other',
    size: '32px'
  },
  {
    name: 'location-60',
    type: 'other',
    size: '60px'
  },
  {
    name: 'location-stroke-60',
    type: 'other',
    size: '60px'
  },
  {
    name: 'marker-blue-14',
    type: 'other',
    size: '14px'
  },
  {
    name: 'marker-red-14',
    type: 'other',
    size: '14px'
  },
  {
    name: 'pop-cluster-60',
    type: 'other',
    size: '60px'
  },
  {
    name: 'time-25',
    type: 'other',
    size: '25px'
  }
];

export default others;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/others.js